// formatted version of https://github.com/wilddeer/stickyfill/blob/master/src/stickyfill.js#L16
export default function isPositionStickySupported() {
  if (!window) return;

  const testNode = window.document.createElement('div');

  return ['', '-webkit-', '-moz-', '-ms-'].some((prefix) => {
    try {
      testNode.style.position = `${prefix}sticky`;
    } catch (e) {}

    return Boolean(testNode.style.position);
  });
}
